import { t } from '@lingui/core/macro'

import { MeetingLinkOrder } from '@/core/graphql/types'

export function getStatusLabel(status: string): string {
  switch (status.toLowerCase()) {
    case 'accepted':
      return t`Accepted`
    case 'active':
      return t`Active`
    case 'canceled':
      return t`Canceled`
    case 'completed':
      return t`Completed`
    case 'refused':
      return t`Refused`
    case 'scheduled':
      return t`Scheduled`
    case 'pending':
      return t`Pending`
    case 'consultation_created':
      return t`Consultation created`
    default:
      return status
  }
}

export function getMeetingPlaceValue(meetingPlace: MeetingLinkOrder['meetingPlace']): string {
  if (!meetingPlace) return t`Video visit`
  switch (meetingPlace.placeId) {
    case 'VISIO_CONFERENCE':
      return t`Video visit`
    case 'AT_HOME':
      return t`At home`
    case 'CENTER':
      return t`At clinic`
    case 'SECOND_OPINION':
      return t`Second Opinion`
    default:
      return meetingPlace.description || ''
  }
}
